import React, { useEffect, useState } from "react";
import { Typewriter } from "react-simple-typewriter";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadFull } from "tsparticles";
import "./Home.css";
import particlesOptions from "../../particles.json";
import { Link } from "react-scroll";

function Home() {
  const [init, setInit] = useState(false);

  useEffect(() => {
    if (init) {
      return;
    }

    initParticlesEngine(async (engine) => {
      await loadFull(engine);
    }).then(() => {
      setInit(true);
    });
  }, [init]);

  const handleType = (count) => {
    // access word count number
    console.log(count);
  };

  const handleDone = () => {
    console.log(`Done after 5 loops!`);
  };

  return (
    <section className="home" id="home">
      <div className="background-image">
        <div className="particles-container">
          {init && <Particles options={particlesOptions} />}
        </div>
      </div>
      <div className="intro">
        <div className="intro-content">
          <div className="intro-text">
            <h2 className="greet">
              Hello<span>👋</span>
            </h2>
            <h2 className="name">
              I'm Martha <span>Mwau</span> a
            </h2>
            <h2 className="soft">
              <Typewriter
                words={["Software Engineer.", "Problem Solver.", "Full-Stack Developer.", "MERN Developer", "Freelancer."]}
                loop={10}
                cursor
                cursorStyle="|"
                typeSpeed={60}
                deleteSpeed={50}
                delaySpeed={1200}
                onLoopDone={handleDone}
                onType={handleType}
              />
            </h2>
            <h3>
              Frontend developer | <span>Backend developer</span>
            </h3>
            <Link
              to="contact"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
            >
              <button className="button-container">Hire Me</button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Home;
